import {
  CLEAR_QUERY_STRINGS,
  SET_QRY_STR_MEDIUM,
  SET_QRY_STR_SOURCE,
  SET_QRY_STR_MODE,
  SET_QRY_STR_DEVICE,
  SET_QRY_STR_TCP_MIDDELWARE_PORT,
  SET_QRY_STR_TCP_MIDDELWARE_ADDR,
} from "./queryStringsTypes";

export const setQryStrMedium = (medium) => ({
  type: SET_QRY_STR_MEDIUM,
  payload: medium,
});

export const setQryStrSource = (mode) => ({
  type: SET_QRY_STR_SOURCE,
  payload: mode,
});

export const setQryStrMode = (source) => ({
  type: SET_QRY_STR_MODE,
  payload: source,
});

export const setQryStrDevice = (device) => ({
  type: SET_QRY_STR_DEVICE,
  payload: device,
});
export const setQryStrTCPAddr = (addr) => ({
  type: SET_QRY_STR_TCP_MIDDELWARE_ADDR,
  payload: addr,
});
export const setQryStrTCPPort = (port) => ({
  type: SET_QRY_STR_TCP_MIDDELWARE_PORT,
  payload: port,
});

export const clearQueryStrings = () => ({
  type: CLEAR_QUERY_STRINGS,
});
